import { render, staticRenderFns } from "./ChangeDetectionResultDetail.vue?vue&type=template&id=be473b2e"
import script from "./ChangeDetectionResultDetail.vue?vue&type=script&lang=js"
export * from "./ChangeDetectionResultDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports